import { ReactElement } from "react";

export const LoadingIndicator = (): ReactElement => (
  <div className="flex h-full w-full items-center justify-center">
    <div className="border-primary h-16 w-16 animate-spin rounded-full border-4 border-solid border-t-transparent" />
  </div>
);
